import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const LayersIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.6", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M1 13L9 17L17 13M1 9L9 13L17 9M9 1L1 5L9 9L17 5L9 1Z"
            stroke="#404DB8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
